export class InventoryFooterSprite extends KDCore.Sprite {
  constructor() {
    super();
    this._create();
  }

  drawGold(text) {
    if (!this._textSpr) return;

    this._textSpr.clear();
    this._textSpr.drawTextFull(text, this.settings.goldText.position);
  }

  drawPagesCount(current, max) {
    if (!this._textSpr2) return;

    this._textSpr2.clear();

    const text = current + "/" + max;
    this._textSpr2.drawTextFull(text, this.settings.pageText.position);
  }

  update() {
    super.update();
    if (this._wPulseThread) {
      this._wPulseThread.update();
    }
  }

  disableArrows() {
    this._arrowL.disable();
    this._arrowR.disable();
  }

  _createContent() {
    this._createGoldIcon();
    this._createGoldTextSpr();
  }

  _create() {
    this._loadSettings();
    this._createContent();
    this._createSectionControl();
  }

  _loadSettings() {
    this.settings = this._settingsJSON();
  }

  _settingsJSON() {
    return YsServices.equipmentService.getUIMapInventorySettings();
  }

  _createArrows() {
    let img0, img1, img3;

    this._arrowL = new KDCore.Button();
    img0 = ImageManager.loadInv("inventoryArrowLeft_00");
    img1 = ImageManager.loadInv("inventoryArrowLeft_01");
    img3 = ImageManager.loadInv("inventoryArrowLeft_03");

    this._arrowL.setButtonImages(img0, img1, img0, img3);
    this._arrowL.move(KDCore.Utils.jsonPos(this.settings.pageArrowLeftInSectionPos));
    this._arrowL.disable();
    this._arrowL.addClickHandler(function() {
      SoundManager.playCursor();
      YsServices.equipmentService.invShowPrevPage();
    });
    this.add(this._arrowL);

    this._arrowR = new KDCore.Button();
    img0 = ImageManager.loadInv("inventoryArrowRight_00");
    img1 = ImageManager.loadInv("inventoryArrowRight_01");
    img3 = ImageManager.loadInv("inventoryArrowRight_03");

    this._arrowR.setButtonImages(img0, img1, img0, img3);
    this._arrowR.move(KDCore.Utils.jsonPos(this.settings.pageArrowRightInSectionPos));
    this._arrowR.disable();
    this._arrowR.addClickHandler(function() {
      SoundManager.playCursor();
      YsServices.equipmentService.invShowNextPage();
    });
    this.add(this._arrowR);
  }

  _createGoldTextSpr() {
    this._textSpr = KDCore.Sprite.FromBitmap(this.settings.goldText.textBoxWidth, this.settings.goldText.textBoxHeight);
    this.applyTextSettingsByExtraSettings(this._textSpr, this.settings.goldText);
    this.add(this._textSpr);
  }

  _createGoldIcon() {
    this.goldIcon = YsServices.equipmentService.FromImgI(this.settings.goldIcon);
    this.goldIcon.move(KDCore.Utils.jsonPos(this.settings.goldIconPosition));
    this.add(this.goldIcon);
  }

  _createSectionControl() {
    this._createArrows();
    this._createPageText();
  }

  _createPageText() {
    this._textSpr2 = KDCore.Sprite.FromBitmap(this.settings.pageText.textBoxWidth, this.settings.pageText.textBoxHeight);
    this.applyTextSettingsByExtraSettings(this._textSpr2, this.settings.pageText);
    this.add(this._textSpr2);
    this.drawPagesCount(1, 1);
  }

  _onPulseThread() {
    this._textSpr3.opacity = Math.abs(Math.sin(this._pulseTimer)) * 255;
    this._pulseTimer += 10;

    if (this._pulseTimer >= 30) {
      this._pulseTimer = 0;
      this._pulseCount--;
    }

    if (this._pulseCount <= 0) {
      this._wPulseThread = null;
      this._textSpr3.opacity = 255;
    }
  }
}
